import React from "react";

import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Navbar from "components/MI/Navbar";
import OutlinedButton from "components/layout/form/outlinedButton";
import PersonalData from "../PersonalData";
import RegistrationData from "../RegistrationData";
import UserMenu from "components/layout/userMenuNew";
import TourBalloon from "components/NewTour/TourBallon";

import { useProfilePage } from "../hooks/useProfilePage";
import {
  Body,
  Container,
  ContractAdhesion,
  ContractAdhesionWrap,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
  PanelContainer,
} from "../styles";

const ProfilePage: React.FC = () => {
  const {
    loading,
    editMode,
    setEditMode,
    userInfo,
    activeForm,
    setActiveForm,
    showMobileMode,
    showTour,
    tourStep,
    tourType,
    birthDate,
    phoneNumber,
    shipToAddress,
    shipLetterToAddress,
  } = useProfilePage();

  return (
    <Navbar selected="meus-dados-novo">
      <UserMenu intro />
      <Container>
        <Header>
          <HeaderInfos>
            <HeaderTitle>
              {activeForm === "personal" ? "Meus dados" : "Dados cadastrais"}
            </HeaderTitle>
            <HeaderSubtitle>
              Verifique se todos os seus dados estão corretos.
            </HeaderSubtitle>
          </HeaderInfos>
          {!showMobileMode && (
            <ContractAdhesion
              href="/static/TermoDeAdesaoMI.pdf"
              target="_blank"
            >
              Termo de adesão
            </ContractAdhesion>
          )}
        </Header>
        {showMobileMode && (
          <ContractAdhesionWrap>
            <ContractAdhesion
              href="/static/TermoDeAdesaoMI.pdf"
              target="_blank"
            >
              Termo de adesão
            </ContractAdhesion>
          </ContractAdhesionWrap>
        )}
        <Body>
          <PanelContainer
            showTour={
              tourStep === 1 && tourType === "meus-dados-novo" && showTour
            }
          >
            {activeForm === "personal" && (
              <>
                <PersonalData
                  editMode={editMode}
                  setEditMode={setEditMode}
                  birthDate={birthDate}
                  email={userInfo?.email}
                  phoneNumber={phoneNumber}
                  document={userInfo?.document}
                  userId={userInfo?.userId}
                  customerCode={userInfo?.customerCode}
                />
                {!editMode && (
                  <ContainedButton
                    style={{
                      maxWidth: showMobileMode ? "100%" : "85%",
                    }}
                    type="button"
                    onClick={() => setEditMode(true)}
                  >
                    Editar dados pessoais
                  </ContainedButton>
                )}
                {!editMode && (
                  <OutlinedButton
                    style={{
                      maxWidth: showMobileMode ? "100%" : "85%",
                    }}
                    type="button"
                    onClick={() => setActiveForm("registration")}
                  >
                    Ver dados cadastrais
                  </OutlinedButton>
                )}
              </>
            )}
            {activeForm === "registration" && (
              <>
                <RegistrationData
                  corporateName={userInfo?.corporateName}
                  shipToAddress={shipToAddress}
                  shipLetterToAddress={shipLetterToAddress}
                  customerCode={userInfo?.customerCode}
                  document={userInfo?.document}
                />
                <ContainedButton
                  style={{
                    maxWidth: showMobileMode ? "100%" : "85%",
                  }}
                  type="button"
                  onClick={() => setActiveForm("personal")}
                >
                  Voltar para meus dados
                </ContainedButton>
              </>
            )}
            {showTour && tourStep === 1 && tourType === "meus-dados-novo" && (
              <TourBalloon
                title="Meus dados"
                content="Aqui você encontra o Termo de adesão e as informações do seu cadastro. É possível ainda realizar a troca de senha clicando em Alterar senha."
                position={{
                  left: "592px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  arrowPosition: "left",
                  arrowLeft: "-10%",
                  maxWidth: 320,
                }}
              />
            )}
          </PanelContainer>
        </Body>
      </Container>
      {loading && <Loading />}
    </Navbar>
  );
};

export default ProfilePage;
